<template>
  <div
    :class="`col-1 text bg-${
      getColorMode.sideBar
    } sidemenu position-relative px-0 ${getShowSideBar ? 'show-side-bar' : ''}`"
  >
    <div class="w-100">
      <div class="upper-logo">
        <button @click="toggleSidebar" class="btn btn-outline-secondary my-3">
          <font-awesome-icon
            class="header-title"
            :icon="['fal', 'bars-sort']"
          />
        </button>
        <img
          :src="logo"
          alt="MobySuite logo"
          height="32"
          :class="`ps-3 my-0 mx-auto logo-${getColorMode.background}`"
          v-if="getShowSideBar"
        />
      </div>
    </div>
    <ul
      :class="`nav nav-pills nav-${getColorMode.background} flex-column mb-auto`"
    >
      <li v-for="(value, key) in getMenu" v-bind:key="`menu-item-${key}`">
        <router-link
          :to="{ name: value.route }"
          href="javascript:;"
          :class="{
            'nav-link text-white rounded-0 position-relative': true,
            active: isActive(value.route),
          }"
        >
          <table style="width: 100%">
            <tr>
              <td style="width: 1%">
                <div class="icon">
                  <font-awesome-icon :icon="['fal', value.icon]" />
                </div>
              </td>
              <td>
                <div class="menu-text ms-1">{{ value.name }}</div>
              </td>
            </tr>
          </table>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "Sidebar",
  data() {
    return {
      logo: require("@/assets/images/general/logo-mobydocs.svg"),
      tail: require("@/assets/images/general/tail-mb.svg"),
    };
  },
  created() {
    if (!this.$auth.$vm.state.data.is_admin) {
      this.axios
        .get(`menu_sections?id=${this.$auth.$vm.state.data.id}`)
        .then((result) => {
          let newMenu = result.data.body.data;
          console.log(newMenu);
          let permittedMenuSections = [];
          newMenu.filter((menuSection) => {
            if (menuSection.user_has_permission == true) {
              permittedMenuSections.push(menuSection.name);
            }
          });
          this.setMenuByUser(
            this.getOriginalMenu.filter((menuSection) => {
              if (permittedMenuSections.includes(menuSection.name))
                return menuSection;
            })
          );
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.setMenuByUser(this.getOriginalMenu);
    }
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    ...mapGetters("general", ["getShowSideBar"]),
    ...mapGetters("general", ["getMenu", "getOriginalMenu"]),
  },
  methods: {
    ...mapMutations("general", ["setMenuByUser"]),
    ...mapMutations("general", ["toggleShowSideBar"]),
    toggleSidebar() {
      this.toggleShowSideBar();
    },
    isActive(view) {
      return this.$route.meta.menu == view;
    },
  },
};
</script>
